import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Grid, Icon, IconButton } from '@mui/material'
import moment from 'moment'
import { formatHoursMinutes, formatNumber } from 'core/lib'

function Reservation({ product }) {
	const dispatch = useDispatch()

	const removeProduct = () => {
		if (window.confirm('Rimuovere la prenotazione dal carrello ?')) {
			dispatch({ type: 'removeProduct@cart', product: product })
		}
	}

	return (<div className="product">
		<Grid container spacing={1}>
			<Grid item xs={12}>
				{product.name}

				<div className="options">
					<div className="option">
						<strong>{moment(product.reservation_day).format('DD/MM/YYYY')}</strong><br/>
						{formatHoursMinutes(product.start)} - {formatHoursMinutes(product.end)}
					</div>
				</div>

				<IconButton color="primary" aria-label="elimina" component="span" className="delete" onClick={removeProduct} style={{ float: 'right' }}>
					<Icon>delete</Icon>
				</IconButton>

				<div className="price">{formatNumber(product.price)} €</div>
			</Grid>
		</Grid>
	</div>)
}

export default Reservation
